<template>
    <v-container fluid class="pt-0 px-0">
        <v-dialog v-model="dialog">
            <v-card>
                <v-card-title class="primary white--text">Actualizar CSV</v-card-title>
                <v-card-text>
                    <v-container fluid class="pa-0">
                        <v-row>
                            <v-col cols="12">
                                <v-file-input v-model="inputCSV" @change="previsualizarCsv" :loading="previsualizando"
                                              :placeholder="'Selecciona un fichero CSV'"/>
                            </v-col>
                        </v-row>

                        <v-alert type="warning" class="my-2" dense v-if="inputCSV && !hayCambiosEnCsv">
                            Sin cambios en el CSV
                        </v-alert>

                        <v-row v-if="hayCambiosEnCsv && csvActualizado && jsonActualizado">
                            <v-col cols="12" class="font-weight-bold primary--text body-1">
                                Comparación de valores (original vs modificado)
                                <v-divider/>
                            </v-col>
                            <v-col cols="12">
                                <v-tabs
                                        v-if="tablaIndicador"
                                        v-model="tabP"
                                >
                                    <v-tabs-slider color="primary"/>
                                    <v-tab
                                            v-for="t in tabs"
                                            :key="t"
                                    >
                                        {{ t }}
                                    </v-tab>
                                </v-tabs>
                                <code-diff
                                        v-if="tablaIndicador && tabP === 0" :old-string="csvOriginal"
                                        :new-string="csvActualizado"
                                        outputFormat="side-by-side"/>
                                <code-diff v-if="tablaIndicador && tabP === 1"
                                           :old-string="jsonOriginal" :new-string="jsonActualizado"
                                           outputFormat="side-by-side"
                                           :context="10"/>
                            </v-col>
                        </v-row>
                        <v-divider/>
                        <v-row class="pt-2">
                            <v-col cols="8">
                                <v-btn :disabled="!previsualizado && !hayCambiosEnCsv" :loading="actualizando"
                                       @click="actualizarCsv"
                                       color="primary" depressed>
                                    Actualizar
                                </v-btn>
                            </v-col>
                            <v-col cols="4" class="text-right">
                                <v-btn @click="cerrarDialogCSV" color="error" depressed>
                                    Descartar
                                </v-btn>
                            </v-col>
                        </v-row>

                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-row no-gutters>
            <v-col cols="12">
                <v-toolbar color="primary" class="font-weight-bold white--text">
                    <v-toolbar-title>Indicador Nº {{ id }}</v-toolbar-title>
                </v-toolbar>
                <v-list v-if="tablaIndicador">
                    <v-list-item v-if="tablaIndicador.tipoSolCons">
                        <v-list-item-title>Tipo solución</v-list-item-title>
                        <v-list-item-subtitle>{{ tablaIndicador.tipoSolCons.codigo }}</v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item v-if="!tablaIndicador.tipoSolCons">
                        <v-list-item-title>Tipo solución</v-list-item-title>
                        <v-list-item-subtitle>{{ tablaIndicador.indicador.area.clase }}</v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item v-if="tablaIndicador.tipo">
                        <v-list-item-title>Tipo</v-list-item-title>
                        <v-list-item-subtitle>{{ tablaIndicador.tipo }}</v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title>Indicador</v-list-item-title>
                        <v-list-item-subtitle>{{ tablaIndicador.indicador.codigo }}</v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-subtitle>{{ tablaIndicador.indicador.nombre }}</v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-subtitle>{{ tablaIndicador.indicador.descripcion }}</v-list-item-subtitle>
                    </v-list-item>
                </v-list>
            </v-col>
        </v-row>
        <v-row no-gutters v-if="tablaIndicador">
            <v-col cols="12" class="overflow-x-auto">
                <v-tabs
                        v-model="tab"
                >
                    <v-tabs-slider color="primary"/>
                    <v-tab
                            v-for="t in tabs"
                            :key="t"
                    >
                        Fichero en formato {{ t }}
                    </v-tab>
                </v-tabs>
                <json-viewer v-if="tablaIndicador && tab === 1" :value="json" boxed :expand-depth="10"/>
                <div v-if="tablaIndicador && tab === 0" class="pa-4">
                    <v-simple-table>
                        <template v-slot:default>
                            <tbody>
                            <tr v-for="(rCsv,i) in csv.split('\n')" :key="`rCsv-${i}`">
                                <td v-for="(cCsv,k) in separarFila(rCsv)" :key="`cCsv-${k}`">
                                    {{ cCsv }}
                                </td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </v-col>
        </v-row>
        <v-divider class="my-4"/>
        <v-row no-gutters>
            <v-col cols="8" class="px-4 py-1">
                <v-btn v-if="tablaIndicador" color="primary" depressed @click="descargarCsv()">
                    Descargar CSV
                </v-btn>
                <v-btn v-if="tablaIndicador" color="primary" class="ml-1" depressed @click="modalActualizar()">
                    Actualizar CSV
                </v-btn>
            </v-col>
            <v-col cols="4" class="px-4 py-1 text-right">
                <v-btn color="error" class="ml-1" depressed @click="volver()">
                    Volver
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {VueRouteHelper} from "@/comunes/helpers/VueRouteHelper";
import DescargasHelper from "../../comunes/helpers/DescargasHelper";
import CodeDiff from 'vue-code-diff';
import JsonViewer from 'vue-json-viewer';
import {MOSTRAR_SNACKBAR} from "@/store/store-app";
import {downloadZip} from "client-zip";
import {BlobHelper} from "@/comunes/helpers/BlobHelper";

export default {
    name: 'AdminIndicadoresDetallesPagina',
    components: {
        CodeDiff,
        JsonViewer
    },
    props: {
        id: {type: Number, required: true}
    },
    data: () => ({
        tablaIndicador: null,
        tab: 'CSV',
        tabs: ['CSV', 'JSON'],
        dialog: false,
        inputCSV: null,
        tabP: 'CSV',
        csvActualizado: null,
        jsonActualizado: null,
        previsualizado: false,
        previsualizando: false,
        actualizando: false
    }),
    mounted: function () {
        this.obtener();
    },
    computed: {
        hayCambiosEnCsv() {
            if (!this.csvActualizado) return false;

            return this.csvActualizado !== this.csvOriginal;
        },
        jsonOriginal() {
            if (!this.tablaIndicador) return null;
            return JSON.stringify(JSON.parse(this.tablaIndicador.json.replaceAll('\'', '"')), undefined, 2);
        },
        json() {
            if (!this.tablaIndicador) return null;
            return JSON.parse(this.tablaIndicador.json.replaceAll('\'', '"'));
        },
        csvOriginal() {
            if (!this.tablaIndicador) return null;
            return this.tablaIndicador.csv;
        },
        csv() {
            if (!this.tablaIndicador) return null;
            return this.tablaIndicador.csv;
        },
        separadorCsv() {
            if (!this.csv) return '';
            if (this.csv.split('\n')[0].split(';').length === 1) return ',';
            else return ';';
        }
    },
    watch: {},
    methods: {
        obtener() {
            HttpHelper.get(`admin/tabla-indicadores/${this.id}/obtener`)
                .then((resp) => this.tablaIndicador = resp);
        },
        descargarCsv() {
            const nombre = this.tablaIndicador.tipoSolCons
                ? `${this.tablaIndicador.tipoSolCons.codigo}_${this.tablaIndicador.indicador.codigo}`
                : `${this.tablaIndicador.indicador.area.clase}_${this.tablaIndicador.indicador.codigo}_${this.tablaIndicador.tipo}`

            DescargasHelper.descargarCSVUTF8(`${nombre}.csv`, this.tablaIndicador.csv, "text/plain;charset=utf-8");
        },
        modalActualizar() {
            this.dialog = true;
        },
        previsualizarCsv() {
            if (!this.inputCSV) {
                this.csvActualizado = null;
                return;
            }

            this.previsualizando = true;
            const fileReader = new FileReader();
            fileReader.onload = (e) => {
                const resultado = e.target.result + "";
                HttpHelper.post(`admin/tabla-indicadores/${this.id}/generar-json`, {csv: btoa(resultado)})
                    .then(resp => this.jsonActualizado = JSON.stringify(JSON.parse(resp.json), null, 2))
                    .catch((e) => {
                        console.error(e);
                        this.jsonActualizado = "{}";
                    })
                    .finally(() => this.previsualizando = false);
            };
            fileReader.readAsBinaryString(this.inputCSV);

            const fileReaderTxt = new FileReader();
            fileReaderTxt.onload = (e) => this.csvActualizado = e.target.result;
            fileReaderTxt.readAsText(this.inputCSV);
        },
        cerrarDialogCSV() {
            this.dialog = false;
            this.csvActualizado = null;
            this.jsonActualizado = null;
            this.previsualizado = false;
            this.inputCSV = null;
        },
        async actualizarCsv() {
            this.actualizando = true;
            const csv = {name: "indicador.csv", lastModified: new Date(), input: this.csvActualizado};
            const blob = await downloadZip([csv]).blob();
            const contenidoZip = await BlobHelper.obtenerContenidoB64(blob);
            HttpHelper.post(`admin/tabla-indicadores/${this.id}/actualizar`, {zipCsv: contenidoZip})
                .then(() => {
                    this.cerrarDialogCSV();
                    this.obtener();
                    this.$store.commit(MOSTRAR_SNACKBAR, {
                        texto: this.$t('indicador_actualizado'),
                        color: "success"
                    });
                })
                .finally(() => this.actualizando = false);
        },
        volver() {
            VueRouteHelper.goBack(this.$router);
        },
        separarFila(filaCsv) {
            if (!filaCsv || this.separadorCsv.length === 0) return [];

            let insideQuote = false,
                entry = [];
            const entries = [];

            filaCsv.split('').forEach((character) => {
                if (character === '"') {
                    insideQuote = !insideQuote;
                } else {
                    if (character === this.separadorCsv && !insideQuote) {
                        entries.push(entry.join(''));
                        entry = [];
                    } else {
                        entry.push(character);
                    }
                }
            });

            entries.push(entry.join(''));

            return entries;
        }
    }
};
</script>

<!-- @formatter:off -->
<i18n>
{
  "es": {
    "indicador_actualizado": "Indicador actualizado"
  }
}
</i18n>
<!-- @formatter:on -->